export const icon = {
  textAlign: 'center',
}
